import Navigation from "@/components/Navigation";
import Hero from "@/components/Hero";
import Services from "@/components/Services";
import WebseitencheckTeaser from "@/components/WebseitencheckTeaser";
import Industries from "@/components/Industries";
import References from "@/components/References";
import ReviewsSection from "@/components/ReviewsSection";
import InsightsTeaser from "@/components/InsightsTeaser";
import HomeFAQ from "@/components/HomeFAQ";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";

const Index = () => {
  return (
    <div className="min-h-screen bg-background">
      <Navigation />
      <main id="main-content" tabIndex={-1}>
        <Hero />
        <Services />
        <Industries />
        <References />
        <ReviewsSection />
        <WebseitencheckTeaser />
        <InsightsTeaser />
        <HomeFAQ />
        <Contact />
      </main>
      <Footer />
    </div>
  );
};

export default Index;
